import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  index: number;
  onClick?: () => void;
}
export function ServiceCard({
  icon,
  title,
  description,
  index,
  onClick
}: ServiceCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} onClick={onClick} className="group relative bg-white border border-border hover:border-stone/30 transition-all duration-300 cursor-pointer p-8" data-id="element-248">
      {/* Icon */}
      <div className="inline-flex p-3 bg-cream text-gold mb-6" data-id="element-249">{icon}</div>

      {/* Title */}
      <h3 className="font-heading font-semibold text-xl text-charcoal mb-3 group-hover:text-gold transition-colors" data-id="element-250">
        {title}
      </h3>

      {/* Description */}
      <p className="text-stone leading-relaxed mb-6 text-[15px]" data-id="element-251">
        {description}
      </p>

      {/* CTA */}
      <div className="flex items-center gap-2 text-charcoal group-hover:text-gold font-medium text-sm transition-colors" data-id="element-252">
        <span data-id="element-253">Learn More</span>
        <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" strokeWidth={2} data-id="element-254" />
      </div>

      {/* Hover Effect */}
      <motion.div className="absolute inset-0 border-l-2 border-gold opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-255" />
    </motion.div>;
}